// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3uywo","detailsBorder":"styles_detailsBorder__zKPTy"};